import { CircularProgress } from '@mui/material'
import MuiButton from '@mui/material/Button'
import React from 'react'
import styled from 'styled-components'
// import MuiButton from '@mui/material/Button'

const defaultProps = {
  variant: 'contained',
  disableElevation: true,
}
const propTypes = {}

const StyledButton = styled(MuiButton)`
  height: 56px;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.2px;
  text-transform: none;
  border-radius: 100px;
  padding: 6px 20px;
  font-family:
    -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue',
    Arial, 'Noto Sans', 'Liberation Sans', sans-serif, 'Apple Color Emoji',
    'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
`

const Button = React.forwardRef((props, ref) => {
  const { loading, startIcon, disabled, children, ...rest } = props

  const effectiveStartIcon = loading ? (
    <CircularProgress size={16} color="inherit" />
  ) : (
    startIcon
  )

  return (
    <StyledButton
      ref={ref}
      startIcon={effectiveStartIcon}
      disabled={disabled || Boolean(loading)}
      {...rest}
    >
      {children}
    </StyledButton>
  )
})

Button.defaultProps = defaultProps
Button.propTypes = propTypes
Button.displayName = 'Button'

export default Button
